<template>
  <date-picker :label="label || title" first-day-of-week="1" v-model="val"></date-picker>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';
import DatePicker from '../DatePicker';
import moment from 'moment';

export default {
  mixins: [EventMixin],
  components: {DatePicker},
  props: {
    value: {
      type: undefined,
      default: moment().startOf('day').unix()
    },
    name: String,
    label: String,
    title: String,
  },
  mounted() {
    this.set_default_value();
  },
  updated() {
    this.set_default_value();
  },
  methods: {
    set_default_value () {
      if (typeof(this.value[this.name]) == "undefined" || this.value[this.name] == null || this.value[this.name] == "") {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, moment().startOf('day').unix());
        this.$emit("input", value);
      }
    }
  },
  computed: {
    val: {
      get () {
        return moment.unix(_.get(this.value, this.name)||moment().unix()).toDate();
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, moment(val).unix());
        this.$emit("input", value);
      }
    }
  }
}
</script>
